import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PageHeaderProps {
  title: string;
  description?: string;
  children?: ReactNode;
  /** Override the gradient from color, e.g. "from-blue-600/10" */
  gradientFrom?: string;
  className?: string;
}

export function PageHeader({
  title,
  description,
  children,
  gradientFrom = "from-primary/10",
  className,
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-2xl bg-gradient-to-br via-primary/5 to-background border p-4 sm:p-6 md:p-8",
        gradientFrom,
        className
      )}
    >
      <div className="absolute inset-0 bg-grid-white/10 [mask-image:linear-gradient(0deg,white,rgba(255,255,255,0.6))] pointer-events-none" />
      <div className="relative flex flex-col gap-3 sm:gap-4 md:flex-row md:items-center md:justify-between">
        <div className="min-w-0">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text">
            {title}
          </h1>
          {description && (
            <p className="text-sm sm:text-base text-muted-foreground mt-1 truncate">
              {description}
            </p>
          )}
        </div>
        {children && (
          <div className="flex flex-wrap gap-2 shrink-0">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
